<script>
import CaregiverBehaviorItem from '@/components/caregiver/CaregiverBehaviorItem.vue'
import CaregiverBehaviorRatingModel from '@/model/CaregiverBehaviorRatingModel'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'

export default {
  mixins: [GenericAPIHandler],
  components: {
    CaregiverBehaviorItem
  },
  props: {
    caregiverId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      filterType: [
        { label: 'ทั้งหมด', value: 'all' },
        { label: 'ฟีดแบ็คดี', value: 'good' },
        { label: 'ฟีดแบ็คไม่ดี', value: 'bad' },
        { label: 'หักคะแนน', value: 'decrease' },
        { label: 'คืนคะแนน', value: 'increase' },
      ],
      filter: 'all',
      page: 1,
      asc: false,
      control: {
        showSelectTypeDialog: false,
        showFeedBackDialog: false,
        showRatingDialog: false,
        showCancelEditDialog: false,
        showSuccessDialog: false,
      },
      type: '',
      behaviorType: '',
      currentRating: 0,
      hoverRating: 0,
      selectedRating: 0,
      pateintResults: [],
      timeout: null,
      patient: '',
      comment: '',
      list: [],
      totalItems: 0,
      limitPerPage: 10,
    }
  },
  mounted () {
    this.getBehaviorCommentList()
  },
  methods: {
    async getBehaviorCommentList () {
      this.$emit('getDashboard')
      try {
        const raw = await this.$api.Caregiver.behaviorCommentList(
          this.caregiverId,
          this.filter,
          this.asc,
          this.limitPerPage,
          this.page
        )
        this.list = [...raw.list]
        this.totalItems = raw.totalItems
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async setPage (val) {
      this.page = val
      await this.getBehaviorCommentList()
    },
    handleType () {
      this.control.showCancelEditDialog = false
      if (this.type === '') {
        setTimeout(() => { this.control.showSelectTypeDialog = true }, 300)
      } else if (this.type === 'feedback') {
        this.control.showSelectTypeDialog = false
        setTimeout(() => { this.control.showFeedBackDialog = true }, 300)
      } else {
        this.behaviorType = 'adjustRating'
        this.control.showSelectTypeDialog = false
        this.getRating()
        setTimeout(() => { this.control.showRatingDialog = true }, 300)
      }
    },
    handleCancel () {
      this.control.showSelectTypeDialog = false
      this.control.showFeedBackDialog = false
      this.control.showRatingDialog = false
      setTimeout(() => { this.control.showCancelEditDialog = true }, 300)
    },
    cancelForm () {
      this.control.showSelectTypeDialog = false
      this.control.showFeedBackDialog = false
      this.control.showRatingDialog = false
      this.control.showCancelEditDialog = false
      this.type = ''
      this.behaviorType = ''
      this.patient = ''
      this.comment = ''
    },
    async getRating () {
      try {
        const raw = await this.$api.Caregiver.behaviorRating(this.caregiverId)
        const dashboard = CaregiverBehaviorRatingModel.fromJSON(raw)
        this.currentRating = dashboard.ratings
        this.hoverRating = dashboard.ratings
        this.selectedRating = dashboard.ratings
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async submit () {
      try {
        await this.$api.Caregiver.behaviorCommentCreate(
          this.caregiverId,
          this.behaviorType,
          parseInt(this.patient.match(/\d+/)[0], 10),
          this.selectedRating,
          this.comment,
        )
        this.getBehaviorCommentList()
        this.cancelForm()
        this.control.showSuccessDialog = true
        setTimeout(() => {
          this.control.showSuccessDialog = false
        }, 1500)
      } catch (error) {
        if (error.response.data.msg === 'rating cannot be the same' || error.response.data.error === 'rating cannot be the same') {
          error.response.data.msg = 'อย่าลืมเพิ่มหรือลดคะแนนหัวใจจากปัจจุบันด้วยนะ!'
        }
        this.showErrorDialog(error)
      }
    },
    async queryPatient (queryString, cb) {
      try {
        let queries = []
        if (queryString) {
          const raw = await this.$api.Caregiver.behaviorPatientSearch(queryString)
          queries = raw.map(r => ({ value: `P${r.id} ${r.name}` }))
        } else {
          queries = [{ value: 'โปรดกรอกข้อมูล' }]
        }

        this.pateintResults = queries.length === 0 ? [{ value: 'ไม่พบข้อมูล' }] : queries
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          cb(this.pateintResults)
        }, 1000 * Math.random())
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    handleAutocompletePatient (item) {
      if (item.value === 'ไม่พบข้อมูล' || item.value === 'โปรดกรอกข้อมูล') {
        this.patient = ''
      }
    },
    mouseEnterHandler (rating) {
      this.hoverRating = rating
    },
    mouseLeaveHandler () {
      this.hoverRating = this.selectedRating
    },
    clickHandler (rating) {
      if (this.selectedRating === 1) {
        this.selectedRating = 0
        this.hoverRating = 0
      } else {
        this.selectedRating = rating
      }
    },
  },
}
</script>

<template>
  <div class="behavior-table-container">
    <div class="header-container">
      <div class="filter-container">
        <div
            v-for="type in filterType"
            :key="type.label"
            class="filter-item"
            :class="['filter-item', { 'selected': type.value === filter }]"
            @click="
              filter = type.value
              page = 1
              getBehaviorCommentList()
            "
        >
          <span>{{ type.label }}</span>
        </div>
      </div>
      <el-button
          :disabled="false"
          type="primary"
          @click="control.showSelectTypeDialog = true"
          style="display: flex; justify-content: center; align-items: center; width: 100px; height: 32px;"
      >
        <img
          src="@/assets/icon/plus.svg"
          width="16"
          height="16"
        />
      </el-button>
    </div>
    <div class="pagination-container">
      <el-pagination
          layout="prev, pager, next"
          :total="totalItems"
          :page-size="limitPerPage"
          @current-change="setPage"
          :current-page.sync="page"
      ></el-pagination>
    </div>
    <div class="summarize-container">
      <span class="number">{{ totalItems }} รายการ</span>
      <div
        class="order"
        @click="
          asc = !asc
          page = 1
          getBehaviorCommentList()
        "
      >
        {{ asc ? 'เก่าไปใหม่' : 'ใหม่ไปเก่า' }}
        <img
          src="https://storage.healthathome.in.th/72223afa-d3d0-46a4-bcbb-cd1ef1ff0eba.svg"
          alt="arrow"
          :style="[asc ? {'transform': 'rotate(180deg)'} : {'transform': 'rotate(0deg)'}, {'transition-duration': '.3s'}]"
        />
      </div>
    </div>
    <div class="list-container">
      <div v-if="list.length === 0" class="comment-container">
        <span>ยังไม่มีรายการพฤติกรรม</span>
      </div>
      <CaregiverBehaviorItem
          v-for="item in list"
          :key="item.id"
          :caregiverId="caregiverId"
          :detail="item"
          @getBehaviorCommentList="getBehaviorCommentList"
      />
    </div>

    <!-- Select Type Dialog -->
    <el-dialog
        :visible.sync="control.showSelectTypeDialog" :showClose="false"
        :closeOnClickModal="false" style="margin-top: 12vh;" width="30%"
    >
      <div style="display: flex; align-items: flex-start; flex-direction: column; align-items: flex-start;">
        <div class="header-18" style="margin-bottom: 40px;">เพิ่มข้อมูลพฤติกรรม</div>
        <div style="display: flex; flex-direction: row; gap: 24px;">
          <div class="title">
            ประเภท
          </div>
          <el-radio-group class="group-vertical radio" v-model="type" style="padding-top: 7px; display: flex; flex-direction: column;">
            <el-radio label="feedback" style="margin-bottom: 12px;">ฟีดแบ็ค</el-radio>
            <el-radio label="rating">คะแนนหัวใจ</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span class="dialog-footer" slot="footer" style="margin-top: 10px;">
        <el-button
            class="secondary-button"
            style="margin-top: 10px;"
            @click="handleCancel()"
            plain="plain"
        >
          ยกเลิก
        </el-button>
        <el-button
            class="edit"
            type="primary"
            style="margin-top: 10px;"
            @click="handleType()"
            :disabled="type === ''"
        >
          ไปต่อ
        </el-button>
      </span>
    </el-dialog>

    <!-- Feedback Dialog -->
    <el-dialog
        :visible.sync="control.showFeedBackDialog" :showClose="false"
        :closeOnClickModal="false" style="margin-top: 5vh;" width="30%"
    >
      <div style="display: flex; align-items: flex-start; flex-direction: column; align-items: flex-start;">
        <div class="header-18" style="margin-bottom: 40px;">ฟีดแบ็ค</div>
        <div style="display: flex; flex-direction: row; gap: 24px;">
          <div class="title">
            ประเภท
          </div>
          <el-radio-group class="group-vertical radio" v-model="behaviorType" style="padding-top: 7px; display: flex; flex-direction: column;">
            <el-radio label="good" style="margin-bottom: 12px;">ฟีดแบ็คดี</el-radio>
            <el-radio label="bad">ฟีดแบ็คไม่ดี</el-radio>
          </el-radio-group>
        </div>
        <div style="margin-top: 44px; display: flex; flex-direction: row; gap: 24px; width: 100%;">
          <div class="title">
            เคส
          </div>
          <el-autocomplete
              class="hospital auto-complete-hospital"
              style="width: 100%;"
              :disabled="false"
              v-model="patient"
              placeholder="เลขคนไข้ หรือ ชื่อผู้ติดต่อ"
              :fetch-suggestions="queryPatient"
              @select="handleAutocompletePatient"
              suffix-icon="el-icon-search"
          ></el-autocomplete>
        </div>
        <div style="margin-top: 24px; display: flex; flex-direction: row; gap: 24px; width: 100%;">
          <div class="title">
            รายละเอียด
          </div>
          <el-input
              type="textarea"
              :rows="3"
              v-model="comment"
              placeholder="รายละเอียดฟีดแบ็ค"
          ></el-input>
        </div>
      </div>
      <span class="dialog-footer" slot="footer" style="margin-top: 10px;">
        <el-button
            class="secondary-button"
            style="margin-top: 10px;"
            @click="handleCancel()"
            plain="plain"
        >
          ยกเลิก
        </el-button>
        <el-button
            class="edit"
            type="primary"
            style="margin-top: 10px;"
            @click="submit()"
            :disabled="behaviorType === '' || patient.trim().length === 0 || comment.trim().length === 0"
        >
          บันทึก
        </el-button>
      </span>
    </el-dialog>

    <!-- Rating Dialog -->
    <el-dialog
        :visible.sync="control.showRatingDialog" :showClose="false"
        :closeOnClickModal="false" style="margin-top: 5vh;" width="30%"
    >
      <div style="display: flex; align-items: flex-start; flex-direction: column; align-items: flex-start;">
        <div class="header-18" style="margin-bottom: 40px;">คะแนนหัวใจ</div>
        <div style="display: flex; flex-direction: row; gap: 24px;">
          <div class="title">
            คะแนนหัวใจ
          </div>
          <div class="rating-container">
            <div
                class="heart-container"
                @mouseleave="mouseLeaveHandler()"
            >
              <div
                  v-for="(_, index) in new Array(5)"
                  :key="'rating-' + index"
                  class="heart"
                  @mouseenter="mouseEnterHandler(index + 1)"
                  @click="clickHandler(index + 1)"
              >
                <img
                    v-if="hoverRating >= index + 1"
                    src="https://storage.healthathome.in.th/61015dc9-ddeb-4a29-b9af-111177d7a5d4.svg"
                    alt="selected"
                />
                <img
                    v-else
                    src="https://storage.healthathome.in.th/5d25a2a8-4f3a-461d-ab34-6b6ff35152a5.svg"
                    alt="not-selected"
                />
              </div>
            </div>
            <div class="box">คะแนนหัวใจปัจจุบัน: {{ currentRating }}</div>
          </div>
        </div>
        <div style="margin-top: 44px; display: flex; flex-direction: row; gap: 24px; width: 100%;">
          <div class="title">
            เคส
          </div>
          <el-autocomplete
              class="hospital auto-complete-hospital"
              style="width: 100%;"
              :disabled="false"
              v-model="patient"
              placeholder="เลขคนไข้ หรือ ชื่อผู้ติดต่อ"
              :fetch-suggestions="queryPatient"
              @select="handleAutocompletePatient"
              suffix-icon="el-icon-search"
          ></el-autocomplete>
        </div>
        <div style="margin-top: 24px; display: flex; flex-direction: row; gap: 24px; width: 100%;">
          <div class="title">
            รายละเอียด
          </div>
          <el-input
              type="textarea"
              :rows="3"
              v-model="comment"
              placeholder="รายละเอียดความดีหรือความผิด"
          ></el-input>
        </div>
      </div>
      <span class="dialog-footer" slot="footer" style="margin-top: 10px;">
        <el-button
            class="secondary-button"
            style="margin-top: 10px;"
            @click="handleCancel()"
            plain="plain"
        >
          ยกเลิก
        </el-button>
        <el-button
            class="edit"
            type="primary"
            style="margin-top: 10px;"
            @click="submit()"
            :disabled="behaviorType === '' || patient.trim().length === 0 || comment.trim().length === 0"
        >
          บันทึก
        </el-button>
      </span>
    </el-dialog>

    <!-- Cancel Create Dialog -->
    <el-dialog :visible.sync="control.showCancelEditDialog" :closeOnClickModal="false" :showClose="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="dialog-header-18" style="margin-left: 17px;">คุณต้องการยกเลิกการลงข้อมูล ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button
            class="secondary-button"
            @click="handleType()"
            plain="plain"
        >
          ยกเลิก
        </el-button>
        <el-button type="primary" @click="cancelForm()" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>

    <!-- Success Update Dialog -->
    <el-dialog :visible.sync="control.showSuccessDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; align-items: center; margin-top: 30px;  margin-bottom: 35px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/faa9aca8-773e-44a3-b4cf-558d8e173c21.svg" />
        <div style="margin-left: 17px; display: flex; flex-direction: column;">
          <div class="dialog-header-18">เย่! แก้ไขข้อมูลเรียบร้อย</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss">
.el-dialog__body {
  padding: 40px 56px !important;
}

.el-input__inner {
  font-size: 18px;

  &::placeholder {
    color: #D5D6DB;
    font-family: "Sukhumvit-Medium";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}
</style>

<style scoped lang="scss">
  .behavior-table-container {
    margin-top: 64px;
    display: flex;
    flex-direction: column;

    .header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 16px;
      border-bottom: 1.5px solid #E9EAED;

      .filter-container {
        display: flex;
        flex-direction: row;
        gap: 4px;

        .filter-item {
          display: flex;
          height: 32px;
          padding: 2px 16px;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition-duration: .3s;

          span {
            color: #676E81;
            text-align: center;
            font-family: "Sukhumvit-SemiBold";
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 40.5px;
          }

          &.selected {
            border-radius: 8px;
            background: var(--Brand-Brand-10, #EDF3FF);

            span {
              font-family: "Sukhumvit-Bold";
              font-weight: 700;
              color: #5489FF;
            }
          }

          &:hover {
            border-radius: 8px;
            background: var(--Brand-Brand-10, #EDF3FF);

            span {
              font-family: "Sukhumvit-SemiBold";
              font-weight: 600;
              color: #5489FF;
            }
          }
        }
      }
    }

    .pagination-container {
      margin-top: 16px;
      display: flex;
      justify-content: flex-end;
    }

    .summarize-container {
      margin-top: 6px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .number {
        color: #434B61;
        font-family: "Sukhumvit-Bold";
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
      }

      .order {
        color: #5489FF;
        font-family: "Sukhumvit-SemiBold";
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        display: flex;
        align-items: baseline;
        gap: 4px;
        cursor: pointer;

        &:hover {
          opacity: 0.75;
        }
      }
    }

    .list-container {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;

      .comment-container {
        display: flex;
        padding: 24px;
        border-radius: 8px;
        background: #F9F9FA;

        span {
          color: #434B61;
          font-family: "Sukhumvit-Medium";
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
      }
    }
  }

  .header-18 {
    font-family: 'Sukhumvit-Bold';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #434B61;
  }

  .cancel-button {
    min-width: 80.92px;
    border: 1.5px solid #409EFF !important;
    transition: .2s;
    span {
      color: #409EFF;
      transition: .2s;
    }
    &:hover {
      background: #409EFF !important;
      transition: .2s;
      span {
        color: #FFFFFF;
        transition: .2s;
      }
    }
  }

  .title {
    color: #434B61;
    font-family: 'Sukhumvit-Medium';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px;
    min-width: 81px;
  }

  .rating-container {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .heart-container {
      display: flex;
      flex-direction: row;
      gap: 4px;

      .heart {
        width: 40px;
        height: 40px;
        background-color: transparent;
        cursor: pointer;
      }
    }

    .box {
      padding: 8px 16px;
      width: auto;
      background-color: #F1F3F6;
      border-radius: 4px;
      color: #A2A7B2;
      font-family: "Sukhumvit-SemiBold";
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 22px;
    }
  }
</style>
